module.exports = __webpack_public_path__ + "img/icon-mentor.05b2455d.svg";